module.exports = __webpack_public_path__ + "static/media/globeVector.ab7be0e1.svg";